export var SHOW_OVERLAY = 'SHOW_OVERLAY';
export var HIDE_OVERLAY = 'HIDE_OVERLAY';
export var SHOW_HOVER_OVERLAY = 'SHOW_HOVER_OVERLAY';
export var SET_OVERLAY_SCROLL_POS = 'SET_OVERLAY_SCROLL_POS';
export var UNSET_OVERLAY_SCROLL_POS = 'UNSET_OVERLAY_SCROLL_POS';
